import { ConcreteEncodable } from "./ConcreteEncodable";

import { DefaultAccountProfileMappingImplEncoder } from "../../encoder/DefaultAccountProfileMappingImplEncoder";

import * as CubiqTS from "../../index";
import { DefaultAccountProfileMapping } from "../DefaultAccountProfileMapping";

export class DefaultAccountProfileMappingImpl
  extends ConcreteEncodable
  implements DefaultAccountProfileMapping
{
  public static enType: string = "com.bcdfx.model.DefaultAccountProfileMappingImpl";

  /*FID=1*/
  public traderGroupId: CubiqTS.Long | null = null;
  /*FID=2*/
  public defaultAccountCd: string;
  /*FID=3*/
  public defaultAlgoHedgingProfileId: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DefaultAccountProfileMappingImplEncoder.Instance;
    this.setEncodableType(DefaultAccountProfileMappingImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DefaultAccountProfileMappingImpl[" +
      "traderGroupId=" +
      this.traderGroupId +
      "defaultAccountCd=" +
      this.defaultAccountCd +
      "defaultAlgoHedgingProfileId=" +
      this.defaultAlgoHedgingProfileId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
